<template>
	<div>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageOrderDetails.supplier") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p class="supplier-name">
						<span>{{ data.merchant_name }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">Bill to</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ data.bill_to_customer_name }}</span>
					</p>
					<p>
						{{ data.bill_to_customer_address }}
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">Ship to</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ data.ship_to_customer_name }}</span>
					</p>
					<p>
						{{ data.ship_to_customer_address }}
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageOrderDetails.deliveryDate") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<el-tag v-if="data.isNotNextDay" type="danger">{{ data.delivery_date }}</el-tag>
					<p v-else>{{ data.delivery_date }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageOrderDetails.comment") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>{{ data.remarks ? data.remarks : "No Comment" }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageOrderDetails.ordered") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>{{ data.order_item_count ? data.order_item_count : "" }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageOrderDetails.include") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>{{ data.order_item_include ? data.order_item_include : "" }}</p>
				</div>
			</el-col>
		</el-row>
		<div class="grid-content bg-purple">
			<span class="span-weight">{{ $t("chatMessageOrderDetails.orderDetails") }}</span>
		</div>
		<div class="order-item" v-for="(item, index) in data.order_item" :key="index">
			<span class="order-item-name"> {{ item.merchant_product_name }}</span>
			<div class="order-item-name">{{ item.qty }} {{ item.merchant_product_unit }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "chat-message-merchant-order-details",

	props: {
		data: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="less" scoped>
.span-weight {
	font-weight: 700;
	font-size: 16px;
	color: black;
	margin-bottom: 20px;
}
.order-item {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	padding-left: 8px;
	.order-item-name {
		font-weight: 500;
		font-size: 14px;
		color: black;
	}
}
.grid-content {
	margin-bottom: 20px;
}

.grid-content p {
	margin-top: 0px;
	margin-bottom: 10px;
}

.supplier-name {
	font-weight: 400;
	font-size: 15px;
	color: black;
}
</style>
